import { useState } from 'react';
import { FiArrowUpRight, FiChevronsLeft, FiChevronsRight, FiLogOut, FiUser } from 'react-icons/fi';
import { Link, NavLink } from 'react-router-dom';
import useAuthStore from 'store/authStore';
import useLogout from 'api/UserResource/useLogout';
import logo from 'assets/images/dark_logo.png';
import NavigationMenu from './NavigationMenu';
import useMenuItems from './useMenuItems';
import './sidebar.css';

export default function PortalSidebar({ mobile = false, onNavigate, closeButton }) {
    const [collapsed, setCollapsed] = useState(() => {
        try { return !mobile && localStorage.getItem('akello-sidebar-collapsed') === 'true'; } catch { return false; }
    });
    const changeCollapsed = (value) => {
        setCollapsed(value);
        try { localStorage.setItem('akello-sidebar-collapsed', String(value)); } catch { /* Optional preference. */ }
    };
    const { userProfile: profile, roles } = useAuthStore();
    const { mutate, isLoading } = useLogout();
    const items = useMenuItems();
    const name = [profile?.first_name, profile?.last_name].filter(Boolean).join(' ') || 'My account';
    const initials = [profile?.first_name, profile?.last_name].filter(Boolean).map((part) => part[0]).join('').slice(0, 2).toUpperCase();
    return <aside className={`portal-sidebar${mobile ? ' portal-sidebar-mobile' : collapsed ? ' is-collapsed' : ''}`} aria-label="Portal sidebar">
        <header className="portal-sidebar-header">
            <Link to="/books" aria-label="Akello Library home" onClick={onNavigate}><img src={logo} alt="Akello Library" /></Link>
            {mobile ? closeButton : <button type="button" className="portal-sidebar-collapse" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} aria-expanded={!collapsed} onClick={() => changeCollapsed(!collapsed)}>{collapsed ? <FiChevronsRight aria-hidden="true" /> : <FiChevronsLeft aria-hidden="true" />}</button>}
        </header>
        <div className="portal-sidebar-context"><span className="portal-workspace-dot" aria-hidden="true" />
            <span>{roles?.[0] || 'Library'} portal</span></div>
        <NavigationMenu items={items} onNavigate={onNavigate} compact={collapsed} idPrefix={mobile ? 'mobile-navigation' : 'desktop-navigation'} />
        <footer className="portal-sidebar-footer">
            <NavLink to="/my-account" aria-label={collapsed ? `Manage profile for ${name}` : undefined} title={collapsed ? name : undefined} className="portal-account" activeClassName="is-active" onClick={onNavigate}>
                <span className="portal-avatar" aria-hidden="true">{profile?.avatar ? <img src={profile.avatar} alt="" /> : initials || <FiUser />}</span>
                <span className="portal-account-details"><strong>{name}</strong><span>Manage your profile</span></span>
                <FiArrowUpRight aria-hidden="true" />
            </NavLink>
            <div className="portal-sidebar-utilities">
                <Link to="/books" onClick={onNavigate} aria-label="Back to library" title="Back to library"><span>Back to library</span><FiArrowUpRight aria-hidden="true" /></Link>
                <button type="button" onClick={() => mutate()} disabled={isLoading} aria-label={isLoading ? "Signing out…" : "Sign out"} title="Sign out">
                    <FiLogOut aria-hidden="true" /><span>{isLoading ? 'Signing out…' : 'Sign out'}</span>
                </button>
            </div>
        </footer>
    </aside>;
}
